/**
 * ERİŞİM JETONU — YALNIZ BELLEKTE.
 *
 * `localStorage` KULLANILMAZ. Oradaki değeri sayfada çalışan her betik
 * okuyabilir; tek bir XSS açığı jetonu sızdırır ve jeton 15 dakika boyunca
 * geçerli kalır. Bellekte tutulan değer sekme kapanınca yok olur.
 *
 * Sayfa yenilendiğinde jeton kaybolur — bu bir eksiklik değil, tasarımdır.
 * Yenileme çerezi httpOnly olarak tarayıcıda durduğu için uygulama açılışta
 * `/kimlik/yenile` çağırıp oturumu sessizce geri kurar.
 *
 * Zustand yerine düz modül değişkeni kullanılıyor: bu değere React ağacının
 * DIŞINDAN (istek katmanı) erişilmesi gerekiyor. Zustand'da da mümkün ama
 * jetonu bir "durum" yapmak onu React DevTools'ta görünür kılar.
 */

let erisimJetonu: string | null = null;

export function erisimJetonuAl(): string | null {
  return erisimJetonu;
}

export function erisimJetonuYaz(jeton: string): void {
  erisimJetonu = jeton;
}

export function erisimJetonuSil(): void {
  erisimJetonu = null;
}
